import React,{useEffect} from "react";
import { useParams } from "react-router";
import DemoRegister from "../components/BookDemo/DemoRegister";
import DemoSchedule from "../components/BookDemo/DemoSchedule";
import SuccessMessage from "../components/BookDemo/SuccessMessage";
import { initGA, initPixel } from "../helpers/CampaignEvents";

const BookaDemo = () => {
  const { component } = useParams();

  useEffect(() => {
    initPixel()
    initGA()
  }, [])

  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">
          {component === "schedule-demo" ? (
            <DemoSchedule />
          ) : component === "success" ? (
            <SuccessMessage />
          ) : (
            <DemoRegister subject={component} />
          )}
        </div>
      </div>
    </div>
  );
};

export default BookaDemo;
